import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'timeAgo'
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: any, args: any[]): any {
    if (value) {
      return moment(value).from(new Date());
    } else {
      return '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/time-ago.pipe.ts